<template>
  <div>
    <span
      v-if="hasDataId"
      v-b-tooltip.hover
      class="badge badge-light-success"
      :title="tooltipText"
    >
      <span
        class="material-icons-outlined align-middle mr-25"
        style="font-size: 1rem"
      >verified</span>
      {{ statusLabel }}
    </span>
    <span
      v-else
      v-b-tooltip.hover
      class="badge badge-light-warning"
      :title="tooltipText"
    >
      <span
        class="material-icons-outlined align-middle mr-25"
        style="font-size: 1rem"
      >report_problem</span>
      {{ statusLabel }}
    </span>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    row: Object,
    field: [String, Object, Boolean],
  },
  computed: {
    hasDataId() {
      return !!this.row?.HasSeyirDriverDataId
    },
    statusLabel() {
      return this.row?.EmployeeAnalysisStatusLabel || (this.hasDataId ? 'Yapılandırma Tamam' : 'Yapılandırma Eksik')
    },
    tooltipText() {
      if (this.row?.EmployeeRecommendationMessage) return this.row.EmployeeRecommendationMessage
      return this.hasDataId
        ? 'SeyirDriverDataId tanımlı; otomatik sorgu çalışabilir.'
        : 'SeyirDriverDataId tanımsız; bu sürücü için otomatik sorgu yapılamaz.'
    },
  },
}
</script>
